module.exports = __webpack_public_path__ + "static/media/raleway.45c729f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/raleway.png
// module id = 1444
// module chunks = 0